module.exports = __webpack_public_path__ + "img/app-bar-logo.01b13a8f.svg";